module.exports = __webpack_public_path__ + "static/img/详情页设计-详情页延展.e1cada1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10002/详情页设计-详情页延展.png
// module id = R/zV
// module chunks = 1